import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgProgress } from '@ngx-progressbar/core';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { AppState } from '../../services/app.service';
import { DateToConvert, Driver, IFilter } from './verification-drivers.model';
import { DriversService } from '../../services/drivers.service';
import { DriversModalComponent } from '../drivers-modal/drivers-modal.component';
import { User } from '../../models/user';

@Component({
    selector: 'self-ins-verification-drivers',
    templateUrl: './verification-drivers-page.component.html',
    styleUrls: ['./verification-drivers-page.component.scss']
})
export class VerificationDriversComponentPage implements AfterViewInit {
    @ViewChild(MatSort) public sort: MatSort | undefined;
    public displayedColumns = ['firstName', 'lastName', 'dateOfBirth', 'hiredOn', 'licensedState', 'licenseNumber', 'yearsDrivingExperience', 'termDate', 'action'];
    public confirmData = false;
    public submitted = false;
    public gridSearchValue = '';
    public dsGridFilter = [
        {
            value: IFilter.activeDrivers, label: 'Active Drivers'
        },
        {
            value: IFilter.allDrivers, label: 'All Drivers'
        },
        {
            value: IFilter.terminatedDrivers, label: 'Terminated Drivers'
        }];
    public gridFilterValue = IFilter.activeDrivers;
    public user: User = this.appState.user.getValue();
    public drivers = new MatTableDataSource<Driver>([]);
    public qnum: number = 0;
    public qsuffix: string = '';
    @ViewChild('modal') public modal!: DriversModalComponent;
    private origDrivers: Driver[] = [];
    public constructor(private router: Router,
                       private activeRouter: ActivatedRoute,
                       private appState: AppState,
                       private toastrService: ToastrService,
                       private progressBar: NgProgress,
                       private driversService: DriversService)
    {
        this.activeRouter.queryParams.subscribe(params => {
            this.qnum = params['qnum'];
            this.qsuffix = params['qsuffix'];

            this.updateDriversGrid();
        });
    }

    public ngAfterViewInit() {
        this.sort?.sort({ id: 'termDate', start: 'asc', disableClear: false });
        this.drivers.sort = this.sort || null;
    }

    public filterGrid(event: IFilter) {
        const day = (new Date().getDate()).toString();
        const month = (new Date().getMonth() + 1).toString();
        const year = (new Date().getFullYear()).toString();
        const today = new Date(month+'-'+day+'-'+year);
        switch (event) {
            case IFilter.activeDrivers:
                this.drivers.data = this.origDrivers.filter((driver) =>
                    (driver.termDate ? new Date(driver.termDate as string) > today : true)
                );
                break;
            case IFilter.allDrivers:
                this.drivers.data = this.origDrivers;
                break;
            case IFilter.terminatedDrivers:
                this.drivers.data = this.origDrivers.filter((driver) =>
                    (driver.termDate ? new Date(driver.termDate as string) <= today : false)
                );
                break;
        }
    }

    public onEditDriver(driver: Driver) {
        driver.isEditing = true;
        this.modal.show(driver);
    }

    public addDriver() {
        const newDriver = {
            isEditing: false
        } as any;
        this.modal.show(newDriver);
    }

    public onSaveDriver(driver: Driver) {
        const driverToUpdate = driver;
        if (!driverToUpdate.id) {
            delete driverToUpdate.isEditing;
        }
        const request = driverToUpdate.id ?
            this.driversService.updateDriver(driverToUpdate) :
            this.driversService.addDriver(this.qnum, this.qsuffix, driverToUpdate);
        this.progressBar.ref().start();
        request.pipe(
            finalize(() => this.progressBar.ref().complete()),
        ).subscribe(() => {
            this.toastrService.success('Driver Successfully ' + (driverToUpdate.id ? 'Updated' : 'Added'));
            this.updateDriversGrid();
        },
            (e) => this.toastrService.error(e.message)
        )
    }

    public updateDriversGrid() {
        this.driversService.getDrivers(this.qnum, this.qsuffix).subscribe((drivers) => {
            this.drivers.data = drivers.map((driver: any) => {
                Object.keys(driver).forEach((d) => {
                    if (driver[d] && DateToConvert.some((dtc) => dtc === d)) {
                        driver[d] = new Date(driver[d]);
                        driver[d] = driver[d].getFullYear() + '-' + ('0' + (driver[d].getMonth() + 1)).slice(-2) + '-' + ('0' + (driver[d].getDate())).slice(-2);
                    }
                });
                return driver;
            });
            this.origDrivers = [...this.drivers.data];
            this.filterGrid(this.gridFilterValue);
        })
    }

    public applySearch() {
        this.drivers.filter = this.gridSearchValue.trim().toLowerCase();
    }

    public onSubmit() {
        this.submitted = true;
        if (!this.confirmData) {
            return;
        }
        this.router.navigate(['/coverage-proposal', this.qnum, this.qsuffix]);
    }
}
